const SESSION_STORAGE_KEY = {
    X_REQUEST_ID: 'X-Request_Id',
    APIM_KEY: 'APIM_Key',
    THEME: "theme"
  };
  
  export default SESSION_STORAGE_KEY;
  